import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import MenuPreparationBomDashboardViewModel from "../view_models/menu_preparation_bom_view_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import SizedDiv from "../../../commons/ui/sized_div";
import Select from "react-select";

export default class MenuPreparationBomDashboardCreateWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<MenuPreparationBomDashboardViewModel>>
                {(vm) => (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2">
                        {/* The Modal */}
                        <div className="relative bg-white rounded-lg shadow-lg mt-10 px-5 w-full max-w-4xl max-h-[83vh] overflow-y-auto">
                            <button
                                className="text-red-500 absolute right-3 top-3"
                                onClick={() => vm.resetCreateForm()}
                            >
                                <FontAwesomeIcon icon={faX} />
                            </button>

                            {/* Header */}
                            <div className="px-4 py-6">
                                <h1 className="font-bold">Hasil Menu</h1>
                                <div className="w-full flex space-x-4 items-center">
                                    <div className="flex-grow">
                                        <Select
                                            placeholder="Pilih Hasil"
                                            className="basic-single w-full"
                                            classNamePrefix="select"
                                            isClearable
                                            isSearchable
                                            name="item"
                                            options={vm.menuItemOptions.map(
                                                (item) => ({
                                                    label: `${item.item} - ${item.materialCode}`,
                                                    value: item.id,
                                                })
                                            )}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                            onChange={(option) => {
                                                if (option) {
                                                    vm.updateResultItemId(
                                                        option.value
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <SizedDiv height={12.0} />

                            {/* Menu Prepare List */}
                            <div className="overflow-x-auto">
                                <h1 className="font-bold">
                                    Daftar Menu Prepare
                                </h1>
                                <table className="table-auto w-full text-center border-collapse my-2">
                                    <thead>
                                        <tr className="bg-gray-300">
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Nama Item
                                            </th>
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Material Code
                                            </th>
                                            <th className="p-2 border border-gray-400 w-1/5">
                                                Quantity
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Empty State */}
                                        {vm.createMprMap.size === 0 && (
                                            <tr>
                                                <td
                                                    colSpan={3}
                                                    className="p-2 border border-gray-400"
                                                >
                                                    <h3>Tidak ada item</h3>
                                                </td>
                                            </tr>
                                        )}

                                        {[...vm.createMprMap.values()].map(
                                            (mpr) => (
                                                <tr key={mpr.mprId}>
                                                    <td className="p-2 border border-gray-400">
                                                        {mpr.mprName}
                                                    </td>
                                                    <td className="p-2 border border-gray-400">
                                                        {mpr.mprMaterialCode}
                                                    </td>
                                                    <td className="p-2 border border-gray-400">
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            value={mpr.mprQty}
                                                            placeholder="Qty"
                                                            className="w-full border rounded-lg px-3 py-2 mt-1"
                                                            onChange={(e) => {
                                                                vm.handleUpdateMprQty(
                                                                    mpr.mprId,
                                                                    Number(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                );
                                                            }}
                                                            onInput={(e) => {
                                                                const target =
                                                                    e.target as HTMLInputElement;
                                                                if (
                                                                    target.value.startsWith(
                                                                        "0"
                                                                    ) &&
                                                                    target.value
                                                                        .length >
                                                                        1
                                                                ) {
                                                                    target.value =
                                                                        target.value.replace(
                                                                            /^0+/,
                                                                            ""
                                                                        );
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Footer */}
                            <div className="mt-6 sticky bottom-0 bg-white px-4 py-6 shadow-inner">
                                <div className="w-full flex space-x-4 items-center">
                                    <div className="flex-grow">
                                        <Select
                                            placeholder="Tambah Item ?"
                                            className="basic-single w-full"
                                            classNamePrefix="select"
                                            isClearable
                                            isSearchable
                                            name="item"
                                            options={vm.mprItemOptions
                                                .filter(
                                                    (option) =>
                                                        ![
                                                            ...vm.createMprMap.keys(),
                                                        ].includes(option.id)
                                                )
                                                .map((item) => ({
                                                    label: `${item.item} - ${item.materialCode}`,
                                                    value: item.id,
                                                }))}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                            onChange={(option) => {
                                                if (option) {
                                                    vm.updateSelectedMprId(
                                                        option.value
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                    <button
                                        onClick={() => {
                                            if (vm.createFormSelectedMprId) {
                                                vm.handleAddMpr(
                                                    vm.createFormSelectedMprId
                                                );
                                            }
                                        }}
                                        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 disabled:bg-gray-500"
                                    >
                                        Masukkan
                                    </button>
                                </div>

                                <div className="mt-4">
                                    <button
                                        className="bg-green-500 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg hover:bg-green-600 w-full"
                                        onClick={() => vm.submitMenuPrepBom()}
                                        disabled={vm.createMprMap.size === 0}
                                    >
                                        Simpan Data
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
